
define('text!templates/pages/trade/offer/repeat/index.ejs',[],function () { return '<div id="repeat-sidebar-container">\n</div>\n\n<div id="repeat-navbar-container">\n</div>\n\n<div id="repeat-table-container">\n</div>';});

